import { render, staticRenderFns } from "./QuestionMarkHover.vue?vue&type=template&id=df3894ae&scoped=true&"
import script from "./QuestionMarkHover.vue?vue&type=script&lang=ts&"
export * from "./QuestionMarkHover.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionMarkHover.vue?vue&type=style&index=0&id=df3894ae&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df3894ae",
  null
  
)

export default component.exports